import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { LiteralService } from 'src/app/services/literal/literal.service';

@Component({
  selector: 'app-form-actions',
  templateUrl: './form-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormActionsComponent {
  readonly saveDisabled = input(false);
  readonly cancelLabel = input('cancel');
  readonly saveLabel = input('save');
  readonly cancelAction = output<Event>();
  readonly saveAction = output<Event>();

  constructor(public literalService: LiteralService) {}
}
